import { RiskAssessmentItem } from '../types';
import { RISK_LEVEL_CONFIG } from '../constants';

// 計算風險評級
export const calculateRiskRating = (severity: number, likelihood: number): number => {
    return severity * likelihood;
};

// 獲取風險等級描述
export const getRiskLevel = (rating: number): string => {
    if (rating >= RISK_LEVEL_CONFIG.HIGH.min) return RISK_LEVEL_CONFIG.HIGH.label;
    if (rating >= RISK_LEVEL_CONFIG.MEDIUM.min) return RISK_LEVEL_CONFIG.MEDIUM.label;
    return RISK_LEVEL_CONFIG.LOW.label;
};

// 獲取風險等級顏色
export const getRiskLevelColor = (rating: number): string => {
    if (rating >= RISK_LEVEL_CONFIG.HIGH.min) return RISK_LEVEL_CONFIG.HIGH.color;
    if (rating >= RISK_LEVEL_CONFIG.MEDIUM.min) return RISK_LEVEL_CONFIG.MEDIUM.color;
    return RISK_LEVEL_CONFIG.LOW.color;
};

// 將純 base64 字符串轉換為 data URL 用於顯示圖片
export const base64ToDataURL = (base64String: string): string => {
    if (!base64String) return '';
    if (base64String.startsWith('data:')) return base64String;
    return `data:image/png;base64,${base64String}`;
};

// 驗證風險評估項目數據
export const validateRiskAssessmentItem = (item: any): RiskAssessmentItem => {
    return {
        ...item,
        assessmentResult: {
            yes: item.assessmentResult?.yes || false,
            no: item.assessmentResult?.no || false,
            reason: item.assessmentResult?.reason || ''
        },
        defaultSafetyPrecautions: Array.isArray(item.defaultSafetyPrecautions)
            ? item.defaultSafetyPrecautions.map((precaution: any) => ({
                item: precaution.item || '',
                content: precaution.content || '',
                isChecked: precaution.isChecked || false
            }))
            : [],
        extraSafetyPrecautions: Array.isArray(item.extraSafetyPrecautions)
            ? item.extraSafetyPrecautions.map((precaution: any) => ({
                item: precaution.item || '',
                content: precaution.content || ''
            }))
            : [],
        severity: item.severity || 0,
        likelihood: item.likelihood || 0,
        riskRating: item.riskRating || 0,
        stayHour: Number(item.stayHour) || 0
    };
};

// 檢查項目是否需要特殊處理
export const isSpecialItem = (itemId: string): boolean => {
    return ['1.1'].includes(itemId);
};

export const isYesNoItem = (itemId: string): boolean => {
    return ['1.2', '1.3', '1.5'].includes(itemId);
};

export const isOtherItem = (itemId: string): boolean => {
    return ['1.11', '1.12'].includes(itemId);
};

export const isHourItem = (itemId: string): boolean => {
    return ['1.13'].includes(itemId);
};

export const needsRiskRating = (itemId: string): boolean => {
    return !['1.1', '1.2', '1.3', '1.13'].includes(itemId);
};